import React, { type JSX } from 'react';
import styled from 'styled-components';
import { Space } from 'styles/themeSpaces';
import { Text } from 'styles/themeColors';
import FlexboxContainer from 'components/UI/FlexboxContainer';
import { FontWeight } from 'lib/styles';

const Heading = styled.h5`
  font-size: 20px;
  line-height: 24px;
  margin: ${Space.sp2x} 0;
  font-weight: ${FontWeight.medium}
`;

const ColumnName = styled.div<any>`
  min-width: 120px;
  font-size: ${Space.sp2x};
  line-height: 20px;
  color: ${({ $color }) => $color || Text.primary};
  margin-right: ${Space.sp3x};
`;

const ColumnValue = styled.div<any>`
  min-width: 188px;
  font-size: ${Space.sp2x};
  line-height: 20px;
  color: ${({ $color }) => $color || Text.primary};
`;

const SecondaryText = styled.span`
  color: ${Text.secondary} !important;
`;

const FlexContainer = styled(FlexboxContainer) <any>`
  flex: 1 1 200px;
  padding: ${({ $padding }) => $padding || Space.sp2x};
`;

interface OrderDetailsInformationProps {
  heading?: string;
  rows: { name?: string; value?: JSX.Element | string | null, secondaryText?: string, showSecondaryText?: boolean }[];
  color?: string;
  padding?: string;
}

const OrderInformationTable: React.FC<OrderDetailsInformationProps> = ({
  heading,
  rows,
  color,
  padding,
}) => {
  return (
    <FlexContainer flexDirection="column" $padding={padding}>
      {heading && <Heading>{heading}</Heading>}
      <FlexboxContainer alignItems="baseline" flexDirection="column">
        {rows.map(({ name, value, secondaryText, showSecondaryText }, index) =>
          name && value ? (
            <FlexboxContainer key={index} alignItems="flex-start" justifyContent="flex-start" padding="6px 0">
              <ColumnName $color={color}>{name}</ColumnName>
              <ColumnValue $color={color}>
                {value} {secondaryText && showSecondaryText && (
                  <SecondaryText className="base-italic">{secondaryText}</SecondaryText>
                )}
              </ColumnValue>
            </FlexboxContainer>
          ) : null
        )}
      </FlexboxContainer>
    </FlexContainer>
  );
};

export default OrderInformationTable;